/// <reference path="~/js/global.js"/>
/// <reference path="~/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>
/// <reference path="~/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="~/js/viz/profile/config/Config.js"/>

(function(Backbone, _) {
  "use strict";

  var ns, config;

  ns = window.nspace("ccc.viz.profile.views");
  config = window.ccc.viz.profile.config.Config;

  ns.ProfileView = Backbone.View.extend({
    el: "#data-table-container",
    templateSelector: "#profile-data-table-template",
    name: "ProfileDataTableView",

    initialize: function(options) {
      _.bindAll(this);

      this.initialRenderPromise = $.Deferred();
      this.featuresRenderPromise = $.Deferred();

      this.selectorsModel = options.selectorsModel;

      this.model.on("change", this.render);
      this.selectorsModel.on("change:dataTypeIds", this.render);
      this.selectorsModel.on("change:otherFeatureIds", this.toggleFeatures);
    },

    events: {
      "click .top": "scrollToTop"
    },

    scrollToTop: function() {
      window.scrollTo(0, 0);
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    getFeatureInitialRenderPromise: function() {
      return this.featuresRenderPromise;
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    render: function() {
      var self;

      this.renderPromise = $.Deferred();

      if (!this.selectorsModel.areModelArraysValid()) {
        return;
      }

      self = this;
      this.loadTemplate();

      $.when(this.model.getDataResponse()).done(function() {
        var tableMarkup;

        tableMarkup = self.getTable();

        self.$el.hide().html(tableMarkup);

        self.toggleFeatures();
        self.$el.fadeIn();

        self.initialRenderPromise.resolve();
        self.renderPromise.resolve();
      });
    },

    /**
     * The other features selectors are represented in the model by arbitrary numbers: currently, 1 and 2.
     * We will key in on this when determining which table areas to hide/show.
     */
    toggleFeatures: function() {
      var self, features;

      self = this;
      features = this.selectorsModel.get("otherFeatureIds");

      _.each(config.featureSelectors, function(selector, key) {
        var animationOptions, $el;

        $el = self.$(key);

        // Checking the state of the table rendering; if we're still rendering, don't animate the feature selection; otherwise, animate it.
        animationOptions =
          self.renderPromise.state() === "resolved"
            ? config.animationOptions.on
            : config.animationOptions.off;

        if (!features.length) {
          selector.off($el, animationOptions);
          return;
        }

        if (features[0] === "a") {
          selector.on($el, animationOptions);
          return;
        }

        if (+features === selector.id) {
          selector.on($el, animationOptions);
          return;
        }

        selector.off($el, animationOptions);
      });
    },

    getTable: function() {
      var response;

      // Gather the properties necessary to render the template
      response = _.extend(
        {},
        this.model.get("response"),
        config.changeImages,
        { dataFormats: this.selectorsModel.get("dataTypeIds") },
        { config: config }
      );
      this.introduceDataFormatText(response.data);
      return this.template(response);
    },

    /**
     * Formulating what the name of the data format should be for each indicator report.
     */
    introduceDataFormatText: function(response) {
      var availableDataFormats;

      availableDataFormats = this.selectorsModel.get("dataTypeIds");

      _.each(response, function(indicatorTables) {
        var formatKeys, formatValues;

        formatKeys = _.filter(
          _.keys(indicatorTables.availableDataPrimitives),
          function(formatKey) {
            var primitiveInKeys;

            if (availableDataFormats[0] === "a") {
              return true;
            }

            primitiveInKeys = _.any(availableDataFormats, function(dataFormat) {
              return +formatKey === +dataFormat;
            });

            return primitiveInKeys;
          }
        );

        // No match between the data formats that are available and the data formats that are set, so let's use an empty string.
        if (!formatKeys.length) {
          indicatorTables.dataFormatText = "";
          return;
        }

        // Only one data format, so print that.
        if (formatKeys.length === 1) {
          indicatorTables.dataFormatText =
            indicatorTables.availableDataPrimitives[formatKeys[0]].name;
          return;
        }

        formatValues = _.map(indicatorTables.availableDataPrimitives, function(
          value,
          key
        ) {
          return value.name;
        });

        // Two data formats require a simple and separator.
        if (formatKeys.length === 2) {
          indicatorTables.dataFormatText = formatValues.join(" and ");
          return;
        }

        // Multiple data formats require a comma/space separated list where the last value gets the "and" keyword as well.
        formatValues =
          formatValues.splice(0, formatKeys.length - 1).join(",") +
          ", and " +
          formatValues[0];
        indicatorTables.dataFormatText = formatValues;
      });
    }
  });
})(Backbone, _);
